import React from 'react'
import DeleteModal from './DeleteModal';
import { useHistory } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const CatchUnauthorizedSaveSolutionModal = (props) => {

  const history = useHistory();
  const ct = useCustomTranslation();
  const ht = useCustomHtmlTranslation();

  const onSubmitAction = (values) => {
    return () => Promise.resolve()
  }

  const redirectTo = () => {
    return history.push(ROUTES.TO_REGISTER)
  };


  return (
    <DeleteModal
      modalTitle={ ct('modal.catch_unauthorized_save_solution.title') }
      onSubmitAction={onSubmitAction}
      redirectTo={redirectTo}
      submitTitle={ ct('modal.catch_unauthorized_save_solution.button') }
    >
    { ht('modal.catch_unauthorized_save_solution.text') }
    </DeleteModal>


  )
}

export default CatchUnauthorizedSaveSolutionModal



// WEBPACK FOOTER //
// ./src/components/Modals/CatchUnauthorizedSaveSolutionModal.js